import { useEmailState } from 'components/EmailStateProvider';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';

const useCallRemainingEmailCampaigns = () => {
  const { setEmailState } = useEmailState();
  const { generalApiCall } = useGeneralApiCall();
  const callRemainingEmailCampaigns = async (source) => {
    try {
      const pathname = `/api/crm-email/remaining-email-campaigns-to-send-this-month`;
      const method = 'get';
      const results = await generalApiCall({
        pathname,
        method,
        needsAuthentication: true,
        notShowErrorMessage: true,
        requestSource: source,
        returnCompleteRequest: true,
        returnError: true,
      });
      let remainingCampaigns = 0;
      if (!!results) {
        switch (results?.status) {
          case 200:
            remainingCampaigns = results?.data;
            break;
          case 204:
            remainingCampaigns = null;
            break;
          default:
            remainingCampaigns = 0;
        }
        setEmailState('remainingEmailCampaigns', { remainingCampaigns, isReady: true });
      }
    } catch (error) {}
  };
  return { callRemainingEmailCampaigns };
};

export default useCallRemainingEmailCampaigns;
